export { UpdateAttestation } from './UpdateAttest';
